<template>
  <div class="newsdetail">
    <section class="main">
      <div class="bread">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>首页</el-breadcrumb-item>
          <el-breadcrumb-item>关于粒上皇</el-breadcrumb-item>
          <el-breadcrumb-item>公司新闻</el-breadcrumb-item>
          <el-breadcrumb-item>新闻详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="article">
        <h1>{{info.title}}</h1>
        <div class="news_time">{{info.createDate|formatTime_a}}</div>
        <div class="nline"></div>
        <p v-html="info.content"></p>
        <!-- <p>不知不觉2019年又马上离我们远去了，即将到来的一年很多小伙伴也都开始筹备创业事宜了，当然不例外的很多小伙伴都选择了以加盟的方式开启自己的事业。如今的零食市场竞争十分激烈，如果没有一个好的品牌作为后盾是很难立足的，粒上皇一个发展多年实力强大的优质品牌，很多小伙伴都看中了其发展前景想要加盟，那么新的一年里粒上皇加盟政策出现了哪些变化呢?我们一起来详细了解一下。</p>
        <img src="../assets/img/enterpriser/ceo1.jpg" alt />
        <p>首先，粒上皇的加盟条件并没有太大的变化，依旧是需年满十八周岁，拥有足够的创业资金及一定的经营学习能力，并且能够认同品牌并坚定维护品牌形象等。详细的资料大家可以在粒上皇官网上留言获取。</p>
        <p>其次，粒上皇加盟方式也和之前一样分为单店加盟及区域代理，两种方式所需的资金不同，当然所能享受的权利及优惠也是不同的。单店所需资金并不是很高适合新手及小本创业，区域代理所需的资金要高出很多比较适合资金充足有能力有经验的“老司机”各位创业可根据自身的实际情况选择。</p>
        <p>然后，就是加盟费情况，想必这也是各位小伙伴都十分关心的问题，根据总部给出的相关数据显示2020年粒上皇加盟费并没有太大的变化。详细的费用情况小编就不在赘述了，大家可以在粒上皇官网上留言获取。</p>
        <p>最后，就是总部的扶持情况，总部通过2019年相关的数据及资料分析对于粒上皇加盟扶持进行全面的升级，之前所反馈的不足及缺点总部一一进行了完善，我们只希望各位小伙伴能够通过粒上皇获得自己想要的事业及财富。</p>
        <p>以上就是对2020年粒上皇加盟政策的相关介绍，全新的年全新的开始希望各位小伙伴都能够取得自己想要的事业获得丰厚的财富。如果各位想要加盟粒上皇可以在本站留言总部招商会在24小时电话联系您为您详细介绍品牌情况。</p> -->
      </div>
    </section>
  </div>
</template>

<script>
import {newsdetail} from '../api/index.js'
export default {
  data() {
    return {
      id:'',
      info:{},
    };
  },
  created(){
    this.id=this.$route.query.id;
    this.getInfo();
  },
  filters:{
    formatTime_a(time) {
	  var date = new Date(time);
	  var year = date.getFullYear()
	  var month = date.getMonth() + 1
	  var day = date.getDate()
	  return year + '-' + month + '-' + day
	}
  },
  methods:{
     getInfo(){
      let param={
        id:this.id,
      }
      newsdetail(param).then(res=>{
        console.log(res)
        if(res.resultCode=='0'){
          this.info=res.data;
          // this.list=res.data.list;
          // this.total=res.data.total;
        }
        // this.loading=false;
      })
    },
    goDetail(id){
      this.$router.push({
        path:'newsdetail',
        query:{id:id}
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.newsdetail {
  .article {
    width: 1000px;
    margin: 0 auto;
    text-align: left;
    h1 {
      font-family: 'HarmonyOS Sans SC';
      font-size: 44px;
      color: #333333;
      padding: 52px 0 10px;
    }
    .news_time {
      font-family: 'HarmonyOS Sans SC';
      font-size: 14px;
      color: #7a7a7a;
      line-height: 26px;
      margin-bottom: 20px;
    }
    .nline {
      height: 1px;
      background: #e6e6e6;
      margin-bottom: 30px;
    }
    > img {
      width: 100%;
      margin-bottom: 40px;
      border-radius: 8px;
    }
    p {
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #666666;
      letter-spacing: 0;
      line-height: 30px;
      margin-bottom: 30px;
      text-indent: 30px;
    }
    .margin20 {
      margin-bottom: 20px;
    }
  }
}
</style>
<style lang="scss">
.bread,
.el-breadcrumb {
  width: 100%;
  height: 60px;
  line-height: 60px;
  background: #fafafa;
}
.el-breadcrumb {
  width: 1200px;
  margin: 0 auto;
}
</style>